import { createFileRoute, useRouterState } from '@tanstack/react-router';

import { normalizeCrmCustomerMembershipReturnTo } from '@features/crm-customer-membership';
import { CrmCustomerMembershipPage } from '@pages/crm';

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/membership'
)({
  component: CrmCustomerMembershipRoute,
});

function CrmCustomerMembershipRoute() {
  const navigate = Route.useNavigate();
  const { locale } = Route.useParams();
  const search = Route.useSearch();
  const currentLocation = useRouterState({ select: (state) => state.location.href });
  const filters = {
    ...(search.membershipDateFrom === undefined ? {} : { dateFrom: search.membershipDateFrom }),
    ...(search.membershipDateTo === undefined ? {} : { dateTo: search.membershipDateTo }),
    ...(search.membershipInstructorId === undefined
      ? {}
      : { inductingInstructorId: search.membershipInstructorId }),
    ...(search.membershipStatus === undefined ? {} : { membershipStatus: search.membershipStatus }),
    ...(search.membershipTypeId === undefined ? {} : { membershipTypeId: search.membershipTypeId }),
  };

  return (
    <CrmCustomerMembershipPage
      filters={filters}
      q={search.membershipQ}
      page={search.membershipPage ?? 1}
      onOpenMembership={(membershipId) => {
        void navigate({
          to: '/$locale/crm/memberships/$membershipId',
          params: { locale, membershipId },
          search: { returnTo: normalizeCrmCustomerMembershipReturnTo(currentLocation) },
        });
      }}
      onEditMembership={(membershipId) => {
        void navigate({
          to: '/$locale/crm/memberships/$membershipId',
          params: { locale, membershipId },
          search: { returnTo: normalizeCrmCustomerMembershipReturnTo(currentLocation), edit: '1' },
        });
      }}
      onFiltersChange={(nextFilters) => {
        void navigate({
          replace: true,
          resetScroll: false,
          search: (current) => ({
            ...current,
            membershipDateFrom: nextFilters.dateFrom,
            membershipDateTo: nextFilters.dateTo,
            membershipInstructorId: nextFilters.inductingInstructorId,
            membershipPage: undefined,
            membershipStatus: nextFilters.membershipStatus,
            membershipTypeId: nextFilters.membershipTypeId,
          }),
        });
      }}
      onSearchChange={(membershipQ) => {
        void navigate({
          replace: true,
          search: (current) => ({
            ...current,
            membershipPage: undefined,
            membershipQ,
          }),
        });
      }}
      onPageChange={(membershipPage) => {
        void navigate({
          replace: true,
          search: (current) => ({
            ...current,
            membershipPage: membershipPage === 1 ? undefined : membershipPage,
          }),
        });
      }}
    />
  );
}
